import { type FieldProps, getIn } from "formik";

export const FormikError =
  (form: FieldProps["form"]) =>
  (name: string): boolean => {
    const error = getIn(form.errors, name);
    const touch = getIn(form.touched, name);
    return Boolean(touch && error);
  };
